import PropTypes from "prop-types";
import React from "react";
import Expandable from "web/react/components/expandable/expandable";
import Shipping from "web/react/components/shipping/shipping";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./product-description-shipping.css";


function ProductDescriptionShipping({
    className,
    expressShipping,
    freeReturn,
    freeShipping,
    isSavedForLater,
    leadUrl,
    productAreaAccordions,
    retailerName,
}) {
    return productAreaAccordions ? (
        <div className={className}>
            <Expandable
                renderLabel={() => (
                    <h4>{gettext("in_stock_product.compare_prices.all_shipping_returns.link")}</h4>
                )}
                onClick={(isOpen) => {
                    if (!isOpen) {
                        analytics.event("product area", "click", "open-shipping");
                    }
                }}
            >
                <Shipping
                    freeShippingUrl={"" /* this is always "" in monoprice_buy_option.py */}
                    isSavedForLater={isSavedForLater}
                    leadUrl={leadUrl}
                    retailerName={retailerName}
                    freeShipping={freeShipping}
                    freeReturn={freeReturn}
                    expressShipping={expressShipping}
                />
            </Expandable>
        </div>
    ) : (
        <div className={className}>
            <h4 className={styles.shippingTitle}>
                {gettext("in_stock_product.shipping_returns_label")}
            </h4>
            <Shipping
                freeShippingUrl={""}
                isSavedForLater={isSavedForLater}
                leadUrl={leadUrl}
                retailerName={retailerName}
                freeShipping={freeShipping}
                freeReturn={freeReturn}
                expressShipping={expressShipping}
            />
        </div>
    );
}

ProductDescriptionShipping.propTypes = {
    className: PropTypes.string,
    expressShipping: ShippingOptionPropType,
    freeReturn: PropTypes.bool,
    freeShipping: ShippingOptionPropType,
    isSavedForLater: PropTypes.bool,
    leadUrl: PropTypes.string,
    productAreaAccordions: PropTypes.bool,
    retailerName: PropTypes.string,
};

export default ProductDescriptionShipping;
